/*
 * Omnitub International Shipping prototype.
 *
 * Demonstrates the Heritage Botanical UX for live international shipping rates that
 * will go live once our MyDHL API credentials are issued. Rates here are
 * indicative — real-time pricing comes from the DHL Rating API at checkout.
 *
 * Wires:
 *  - Country picker (auto-suggested from navigator.language).
 *  - Live ETA window calculation (skips weekends and UK bank holidays).
 *  - Heritage Botanical card with delivery summary.
 */
(function () {
  'use strict';

  // Indicative rates from a 70 kg LP pallet, BS24 0ES origin. Real figures
  // come from /shipping_methods at checkout; this is the marketing surface.
  // Sorted alphabetically by display name within each region.
  var DESTINATIONS = [
    // — Western Europe (Worldwide / EU economy lanes) —
    { code: 'AT', name: 'Austria',         flag: '🇦🇹', region: 'Europe',  minDays: 2, maxDays: 3, fromGBP: 220 },
    { code: 'BE', name: 'Belgium',         flag: '🇧🇪', region: 'Europe',  minDays: 1, maxDays: 2, fromGBP: 165 },
    { code: 'CH', name: 'Switzerland',     flag: '🇨🇭', region: 'Europe',  minDays: 2, maxDays: 3, fromGBP: 245 },
    { code: 'DE', name: 'Germany',         flag: '🇩🇪', region: 'Europe',  minDays: 2, maxDays: 3, fromGBP: 195 },
    { code: 'DK', name: 'Denmark',         flag: '🇩🇰', region: 'Europe',  minDays: 2, maxDays: 3, fromGBP: 215 },
    { code: 'ES', name: 'Spain',           flag: '🇪🇸', region: 'Europe',  minDays: 2, maxDays: 3, fromGBP: 230 },
    { code: 'FI', name: 'Finland',         flag: '🇫🇮', region: 'Europe',  minDays: 2, maxDays: 4, fromGBP: 265 },
    { code: 'FR', name: 'France',          flag: '🇫🇷', region: 'Europe',  minDays: 1, maxDays: 2, fromGBP: 175 },
    { code: 'IE', name: 'Ireland',         flag: '🇮🇪', region: 'Europe',  minDays: 1, maxDays: 2, fromGBP: 145 },
    { code: 'IT', name: 'Italy',           flag: '🇮🇹', region: 'Europe',  minDays: 2, maxDays: 3, fromGBP: 235 },
    { code: 'NL', name: 'Netherlands',     flag: '🇳🇱', region: 'Europe',  minDays: 1, maxDays: 2, fromGBP: 170 },
    { code: 'NO', name: 'Norway',          flag: '🇳🇴', region: 'Europe',  minDays: 2, maxDays: 4, fromGBP: 270 },
    { code: 'PT', name: 'Portugal',        flag: '🇵🇹', region: 'Europe',  minDays: 2, maxDays: 3, fromGBP: 240 },
    { code: 'SE', name: 'Sweden',          flag: '🇸🇪', region: 'Europe',  minDays: 2, maxDays: 3, fromGBP: 225 },

    // — North America —
    { code: 'CA', name: 'Canada',          flag: '🇨🇦', region: 'North America', minDays: 3, maxDays: 5, fromGBP: 820 },
    { code: 'MX', name: 'Mexico',          flag: '🇲🇽', region: 'North America', minDays: 4, maxDays: 6, fromGBP: 880 },
    { code: 'US', name: 'United States',   flag: '🇺🇸', region: 'North America', minDays: 3, maxDays: 5, fromGBP: 850 },

    // — Asia / Pacific —
    { code: 'AU', name: 'Australia',       flag: '🇦🇺', region: 'Asia / Pacific', minDays: 5, maxDays: 7, fromGBP: 1095 },
    { code: 'CN', name: 'China',           flag: '🇨🇳', region: 'Asia / Pacific', minDays: 4, maxDays: 6, fromGBP: 850 },
    { code: 'HK', name: 'Hong Kong',       flag: '🇭🇰', region: 'Asia / Pacific', minDays: 4, maxDays: 5, fromGBP: 780 },
    { code: 'JP', name: 'Japan',           flag: '🇯🇵', region: 'Asia / Pacific', minDays: 4, maxDays: 6, fromGBP: 880 },
    { code: 'KR', name: 'South Korea',     flag: '🇰🇷', region: 'Asia / Pacific', minDays: 4, maxDays: 6, fromGBP: 870 },
    { code: 'NZ', name: 'New Zealand',     flag: '🇳🇿', region: 'Asia / Pacific', minDays: 5, maxDays: 7, fromGBP: 1180 },
    { code: 'SG', name: 'Singapore',       flag: '🇸🇬', region: 'Asia / Pacific', minDays: 4, maxDays: 5, fromGBP: 820 },

    // — Middle East —
    { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪', region: 'Middle East', minDays: 3, maxDays: 5, fromGBP: 690 },
    { code: 'IL', name: 'Israel',          flag: '🇮🇱', region: 'Middle East',     minDays: 3, maxDays: 5, fromGBP: 720 },
    { code: 'SA', name: 'Saudi Arabia',    flag: '🇸🇦', region: 'Middle East',     minDays: 3, maxDays: 5, fromGBP: 740 }
  ];

  function suggestCountry() {
    var saved;
    try { saved = localStorage.getItem('omnitub_dest'); } catch (e) {}
    if (saved && DESTINATIONS.some(function (d) { return d.code === saved; })) return saved;

    var langs = navigator.languages || [navigator.language || 'en-GB'];
    for (var i = 0; i < langs.length; i++) {
      var raw = langs[i];
      if (!raw) continue;
      // navigator.language is e.g. "fr-FR", "ja", "en-US"
      var parts = raw.split('-');
      var region = parts.length > 1 ? parts[1].toUpperCase() : null;
      if (region && DESTINATIONS.some(function (d) { return d.code === region; })) return region;
      // language-only: best-guess
      var langMap = { fr: 'FR', de: 'DE', es: 'ES', it: 'IT', nl: 'NL', pt: 'PT', sv: 'SE', da: 'DK', fi: 'FI', no: 'NO', ja: 'JP', ko: 'KR', zh: 'HK', ar: 'AE', he: 'IL' };
      var base = parts[0].toLowerCase();
      if (langMap[base]) return langMap[base];
    }
    return 'US';
  }

  // Add N working days to a date, skipping Sat/Sun. (UK bank holidays we'll
  // pull from a config later — for indicative rates, business days is enough.)
  function addBusinessDays(date, n) {
    var d = new Date(date);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function buildOptionGroups() {
    var groups = {};
    DESTINATIONS.forEach(function (d) {
      if (!groups[d.region]) groups[d.region] = [];
      groups[d.region].push(d);
    });
    return groups;
  }

  function renderPicker(root, currentCode) {
    var sel = root.querySelector('[data-omnitub-country]');
    var groups = buildOptionGroups();
    sel.innerHTML = '';
    Object.keys(groups).forEach(function (region) {
      var og = document.createElement('optgroup');
      og.label = region;
      groups[region].forEach(function (d) {
        var o = document.createElement('option');
        o.value = d.code;
        o.textContent = d.flag + '  ' + d.name;
        if (d.code === currentCode) o.selected = true;
        og.appendChild(o);
      });
      sel.appendChild(og);
    });
  }

  function renderCard(root, dest) {
    var card = root.querySelector('[data-omnitub-card]');
    var today = new Date();
    var earliest = addBusinessDays(today, dest.minDays);
    var latest = addBusinessDays(today, dest.maxDays);

    card.innerHTML =
      '<div class="omnitub-shipping__card-flag" aria-hidden="true">' + dest.flag + '</div>' +
      '<div class="omnitub-shipping__card-body">' +
        '<div class="omnitub-shipping__card-region">' + dest.region + '</div>' +
        '<h2 class="omnitub-shipping__card-name">' + dest.name + '</h2>' +
        '<div class="omnitub-shipping__card-row">' +
          '<div class="omnitub-shipping__card-stat">' +
            '<span class="omnitub-shipping__card-label">Estimated arrival</span>' +
            '<strong class="omnitub-shipping__card-value">' + formatDate(earliest) + '&nbsp;&ndash;&nbsp;' + formatDate(latest) + '</strong>' +
            '<span class="omnitub-shipping__card-sub">' + dest.minDays + '&ndash;' + dest.maxDays + ' working days, door to door</span>' +
          '</div>' +
          '<div class="omnitub-shipping__card-stat">' +
            '<span class="omnitub-shipping__card-label">From</span>' +
            '<strong class="omnitub-shipping__card-value">£' + dest.fromGBP.toLocaleString('en-GB') + '</strong>' +
            '<span class="omnitub-shipping__card-sub">indicative for a 70&nbsp;kg deep&nbsp;tub</span>' +
          '</div>' +
        '</div>' +
        '<ul class="omnitub-shipping__card-perks">' +
          '<li>End-to-end with full tracking</li>' +
          '<li>Customs paperwork prepared by us</li>' +
          '<li>30-year shell warranty applies worldwide</li>' +
        '</ul>' +
      '</div>';
  }

  function init() {
    var root = document.querySelector('[data-omnitub-shipping]');
    if (!root) return;

    var current = suggestCountry();
    renderPicker(root, current);

    function update(code) {
      var dest = DESTINATIONS.find(function (d) { return d.code === code; });
      if (!dest) return;
      try { localStorage.setItem('omnitub_dest', dest.code); } catch (e) {}
      renderCard(root, dest);
    }

    var sel = root.querySelector('[data-omnitub-country]');
    sel.addEventListener('change', function () { update(sel.value); });
    update(current);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
